import { Dialog } from "@mui/material";
import { useCallback, useMemo, useState } from "react";
import { RenderPath } from "./RenderPath";
import { useCreateInternalStateBranch } from "../../state/InternalContext";
import { useCallbacks } from "../../state/InternalContext";

interface OpenDialogButtonProps {
  path: string,
  label: string,
}
/***
 * A button that opens a dialog.
 * The path is the path to the dialog content.
 */
export function OpenDialogButton({ path, label }: OpenDialogButtonProps) {
  const callbacks = useCallbacks();
  const createInternalStateBranch = useCreateInternalStateBranch();

  const [open, setOpen] = useState<boolean>(false);

  const newCallbacks = useMemo(() => {
    return {
      ...callbacks,
      "close-dialog": { func: () => { setOpen(false) } }
    }
  }, [callbacks]);

  const clickHandler: React.MouseEventHandler<HTMLButtonElement> = useCallback((_event: React.MouseEvent<HTMLButtonElement>) => {
    setOpen(true);
  }, [setOpen]);

  // Create a new state branch used in child components in the Dialog
  // and add the close dialog callback to the new state branch
  const BranchComponent = useMemo(() => createInternalStateBranch({
    callbacks: newCallbacks,
  }), [newCallbacks, createInternalStateBranch]);

  return (
    <BranchComponent>
      <button onClick={clickHandler}>{label}</button>
      <Dialog open={open}>
        <RenderPath path={path} ismain={false} />
      </Dialog>
    </BranchComponent>
  );
};